import { useQuery } from '@tanstack/react-query';
import { fetchSecurityGroupsForDealer } from '../services/security-groups';

export function useDealerSecurityGroupsQuery(dealerId: string) {
  return useQuery({
    queryKey: ['security', 'dealers', dealerId, 'groups'],
    queryFn: () => fetchSecurityGroupsForDealer(dealerId),
    enabled: Boolean(dealerId),
  });
}
